module.exports = __webpack_public_path__ + "img/control.5d9315d0.png";